export const extractNumber = (str: string) => parseFloat(str.replace(/[^\d.-]/g, ""));
